import React from 'react';

import { Text } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';

export const Container = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.container, style]} />
);

export const Heading = Text.withConfig({
  variant: 'headerOne',
  margin: 0,
  padding: 0,
});

export const Content = Text.withConfig({
  variant: 'copyOne',
  textAlign: 'center',
  marginY: '$4',
});

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
});
